import Rollbar from 'rollbar'

export const rollbar = new Rollbar({
  accessToken: process.env.REACT_APP_ROLLBAR_TOKEN,
  ignoredMessages: [
    'Network Error',
    'Request aborted',
    'timeout of 0ms exceeded',
    'Script error',
    "Can't find variable: MoatMAK",
    "Can't find variable: _pcmBridgeCallbackHandler",
    "Can't find variable: _AutofillCallbackHandler",
    'window.mraid',
    "document.getElementsByTagName('video')[0].webkitExitFullScreen",
    'RuleSet',
    'expression o',
    'expression r',
    'expression n',
    'UET',
    'DomainData',
    'Can’t find variable pktAnnotationHighliter',
    'Unexpected token', // deprecated browser syntax error, mostly in e2e tests
  ],
  hostSafeList: ['bankrate.com', 'mortgage-rate-table.bankrate.com'],
  captureUncaught: true,
  captureUnhandledRejections: true,
  environment: process.env.REACT_APP_ENV,
  checkIgnore: function (isUncaught, args, payload) {
    return (
      (isUncaught && isBrowserExtension(args, payload)) || //ignore extensions
      (isUncaught && isThirdPartyScript(args, payload)) || //ignore third party scripts
      (isUncaught && isCohesionError(args, payload)) || //ignore some cohesiona error
      navigator.userAgent.indexOf('MSIE') !== -1 || // ignore all IE
      navigator.userAgent.indexOf('Trident') !== -1 || // ignore all IE
      navigator.userAgent.indexOf('Edge/1') !== -1 || // ignore old versions of Edge
      navigator.userAgent.indexOf('Chrome/49') !== -1 || // ignore chrome 49
      window.location.href.indexOf('e2eTestEnabled=true') !== -1 // ignore cypress
    )
  },
  payload: {
    environment: process.env.REACT_APP_ENV,
    client: {
      javascript: {
        source_map_enabled: true,
        code_version: process.env.REACT_APP_CIRCLE_SHA1,
        guess_uncaught_frames: true,
      },
    },
  },
})

const isThirdPartyScript = (args: any[], payload: any) => {
  const stack = payload.body.telemetry[0]?.body?.stack
  return stack && (stack.includes('cohesionapps') || stack.includes('googletagmanager') || stack.includes('cookielaw'))
}

const isBrowserExtension = (args: any[], payload: any) => {
  return (
    payload.body.trace.frames[0].filename.indexOf('extension') !== -1 ||
    payload.body.trace.exception.class === '(unknown)' ||
    payload.body.trace.frames[0].filename === '(unknown)' ||
    payload.body.trace.frames[0].method === '[anonymous]'
  )
}

const isCohesionError = (args: any[], payload: any) => {
  const ignoreList = ['Illegal invocation']
  const errorMsg = payload.body.trace.exception.message
  const lastFrame = payload.body.trace.frames[payload.body.trace.frames.length - 1]
  return lastFrame?.filename?.includes('cdn.cohesionapps.com') && ignoreList.includes(errorMsg)
}
